import React, { useState, useCallback, useEffect, useContext } from 'react';

import {
    Card,
    DisplayText,
    FormLayout,
    Layout,
    Select,
    TextStyle,
    Stack,
    Icon,
    Button,
    Toast,
} from '@shopify/polaris';
import { MobileBackArrowMajor } from '@shopify/polaris-icons';
import { gql, useQuery } from '@apollo/client';
import { DomainContext } from '../domain-context';
import PixelIcon from '../../assets/images/PixelIcon';
const SetTimezone = ({ handleBack, i18n }) => {
    const { domain } = useContext(DomainContext);
    const [timezones, setTimezones] = useState([]);
    const [selectTimezone, setSelectTimezone] = useState();
    const [toastActive, setToastActive] = useState(false);
    const toggleToastActive = useCallback(() => setToastActive((toastActive) => !toastActive), []);
    const GET_TIMEZONES = gql`
    query {
      fetchTimezone{
        allTimezones{
          label
          value
        }
        currentTimezone
      }
    }
  `;
    const { data, loading, error, refetch } = useQuery(GET_TIMEZONES, {
        fetchPolicy: 'network-only',
    });

    useEffect(() => {
        refetch();
    }, [])

    useEffect(() => {
        setTimezones(data?.fetchTimezone?.allTimezones)
        setSelectTimezone(data?.fetchTimezone?.currentTimezone)
    }, [data])

    const updateTimezone = () => {
        fetch('/settings/update_timezone', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ timezone: selectTimezone, shopify_domain: domain }),
        }).then((response) => response.json())
            .then(() => {
                setToastActive(true)
            })
    }
    return (
        <div className="product-extention">
            {
                toastActive && (
                    <Toast content="Saved Successfully" onDismiss={toggleToastActive} />
                )
            }
            <Layout>
                <Layout.Section>
                </Layout.Section>
                <Card title=
                    {
                        <div className="heading_title">
                            <PixelIcon />
                            {i18n.t("timezone_setting")}
                        </div>
                    }>
                    <Card.Section>
                        <div className="billing">
                            <FormLayout>
                                <DisplayText size="small" element="h6">
                                    <TextStyle variation="subdued">{i18n.t("timezone_setting")}</TextStyle>
                                </DisplayText>
                                <Select
                                    label="Select Timezone"
                                    value={selectTimezone}
                                    onChange={(e) => setSelectTimezone(e)}
                                    options={timezones?.length > 0 ? timezones : []}
                                />
                                <div className='button'>
                                    <Button
                                        onClick={() => updateTimezone()}
                                    >Save</Button>
                                </div>
                            </FormLayout>
                        </div>
                    </Card.Section>
                </Card>
            </Layout>
        </div>
    );
};

export default SetTimezone;